export const ANALYTICS_EVENTS = {
    CLICK_SEARCH_BUTTON: "clickSearchButton",
    SYS_RESULT_LOADED: "sysResultLoaded",
    SYS_SCHEDULED_INSPECTIONS_LOADED: "SysScheduledInspectionsLoaded",
    CLICK_SAVE_CHANGES: "clickSaveChanges",
    CLICK_EDIT_CHANGES: "clickEditChanges",
    CLICK_DELETE_CHANGES: "clickDeleteChanges",
    CLICK_DOWNLOAD_BUTTON: "clickDownloadButton",
    CLICK_BULK_UPLOAD_BUTTON: "clickBulkUploadButton",
    CLICK_DENROLL_BUTTON:"clickDeEnrollButton",
    CLICK_NEXT_PAGE_BUTTON: "clickNextPageButton",
    CLICK_PREVIOUS_PAGE_BUTTON: "clickPreviousPageButton",
    CLICK_UPDATE_AGREEMENT_BUTTON: "clickUpdateAgreementButton",
    CLICK_DOWNLOAD_SECTION_BUTTON: "clickDownloadLinkButton",
    CLICK_APPROVE_BUTTON: "clickApproveButton",
    SYS_ADD_USER_ERROR: "sysAddUserFailure",
    SYS_ADD_USER_SUCCESS: "sysAddUserSuccess",
    SYS_EDIT_USER_SUCCESS: "sysEditUserSuccess",
    SYS_EDIT_USER_ERROR: "sysEditUserFailure",
    SYS_DELETE_USER_SUCCESS: "sysDeleteUserSuccess",
    SYS_DELETE_USER_ERROR: "sysDeleteUserFailure",
    SYS_ADD_ROLE_SUCCESS: "sysAddRoleSuccess",
    SYS_ADD_ROLE_ERROR: "sysAddRoleFailure",
    SYS_DOWNLOAD_SUCCESS: "sysDownloadSuccess",
    SYS_DOWNLOAD_ERROR: "sysDownloadFailure",
    SYS_EDIT_ROLE_SUCCESS: "sysEditRoleSuccess",
    SYS_EDIT_ROLE_ERROR: "sysEditRoleFailure",
    SYS_ADD_EMAIL_ALERT_SUCCESS: "sysAddEmailAlertSuccess",
    SYS_ADD_EMAIL_ALERT_ERROR: "sysAddEmailAlertFailure",
    SYS_EDIT_EMAIL_ALERT_SUCCESS: "sysEditEmailAlertSuccess",
    SYS_EDIT_EMAIL_ALERT_ERROR: "sysEditEmailAlertFailure",
    SYS_DELETE_EMAIL_ALERT_SUCCESS: "sysDeleteEmailAlertSuccess",
    SYS_DELETE_EMAIL_ALERT_ERROR: "sysDeleteEmailAlertFailure",
    SYS_ADD_VEHICLE_SUCCESS: "sysAddVehicleSuccess",
    SYS_ADD_VEHICLE_ERROR: "sysAddVehicleFailure",
    SYS_EDIT_VEHICLE_SUCCESS: "sysEditVehicleSuccess",
    SYS_EDIT_VEHICLE_ERROR: "sysEditVehicleFailure",
    SYS_DELETE_VEHICLE_SUCCESS: "sysDeleteVehicleSuccess",
    SYS_DELETE_VEHICLE_ERROR: "sysDeleteVehicleFailure",
    SYS_BULK_UPLOAD_VEHICLE_SUCCESS: "sysBulkUploadVehicleSuccess",
    SYS_BULK_UPLOAD_VEHICLE_ERROR: "sysBulkUploadVehicleFailure",
    SYS_DE_ENROLL_VEHICLE_SUCCESS:"sysDeEnrollVehicleSuccess",
    SYS_DE_ENROLL_VEHICLE_ERROR:"sysDeEnrollVehicleFailure",
    SYS_UPDATE_AGREEMENT_VEHICLE_SUCCESS:"sysUpdateAgreementVehicleSuccess",
    SYS_UPDATE_AGREEMENT_VEHICLE_ERROR:"sysUpdateAgreementVehicleFailure",
    SYS_ADD_DTP_PLANNING_SUCCESS:"sysAddDtpPlanningSuccess",
    SYS_ADD_DTP_PLANNING_ERROR:"sysAddDtpPlanningFailure",
    SYS_EDIT_DTP_PLANNING_SUCCESS : "sysEditDtpPlanningSuccess",
    SYS_EDIT_DTP_PLANNING_ERROR : "sysEditDtpPlanningFailure",
    SYS_DELETE_DTP_PLANNING_SUCCESS:"sysDeleteDtpPlanningSuccess",
    SYS_DELETE_DTP_PLANNING_ERROR:"sysDeleteDtpPlanningFailure",
    SYS_APPROVE_DTP_PLANNING_SUCCESS:"sysApproveDtpPlanningSuccess",
    SYS_APPROVE_DTP_PLANNING_ERROR:"sysApproveDtpPlanningFailure",
    SYS_LINK_DOWNLOAD_SECTION_SUCCESS:"sysLinkDownloadSectionSuccess",
    SYS_LINK_DOWNLOAD_SECTION_ERROR:"sysLinkDownloadSectionFailure",
    SYS_DELETE_UPLOAD_CPKM_SUCCESS:"sysDeleteUploadCpkmSuccess",
    SYS_DELETE_UPLOAD_CPKM_ERROR:"sysDeleteUploadCpkmFailure",
     SYS_BULK_UPLOAD_CPKM_SUCCESS:"sysBulkUploadCpkmSuccess",
    SYS_BULK_UPLOAD_CPKM_ERROR:"sysBulkUploadCpkmFailure",
};
